import { fieldDomId } from "./validation";

export class InvalidFieldFocus {
  constructor(private readonly root: HTMLElement) {}

  apply(errorId: string): boolean {
    const el = this.root.querySelector<HTMLElement>(`#${fieldDomId(errorId)}`);
    if (!el) return false;
    const scroller = el.closest(".nv-card-scroll");
    if (scroller) {
      const fieldBox = el.getBoundingClientRect();
      const scrollerBox = scroller.getBoundingClientRect();
      scroller.scrollTop += fieldBox.top - scrollerBox.top - 24;
    }
    const pageX = typeof window !== "undefined" ? window.scrollX : 0;
    const pageY = typeof window !== "undefined" ? window.scrollY : 0;
    el.focus({ preventScroll: true });
    if (typeof window !== "undefined") window.scrollTo(pageX, pageY);
    return true;
  }
}
